<!-- 管理员登录成功后的页面 -->
<template>
  <div class="admin-layout">
    <Header
      :title="title"
      :name="name"
    />
    <Sidebar />
    <Tabs />
    <Main />
  </div>
</template>

<script>
import ResizeMixin from './mixin/resizeHandler'
import Header from './header/index.vue'
import Sidebar from './sidebar/index.vue'
import Main from './main/index.vue'
import Tabs from './tabs/index.vue'
import resize from '../utils/resize.js'
export default {
  components: {
    Header,
    Sidebar,
    Tabs,
    Main
  },
  mixins: [ResizeMixin],
  data () {
    return {
      title: '',
      name: this.$store.getters.name
    }
  },
  mounted () {
    resize.setPageScaleCover()
  }
}
</script>
<style scoped>
.admin-layout {
  width: 100%;
  height: 100%
}
</style>
